export default __webpack_public_path__ + "static/media/588AF15B-D699-4FDA-9E2B-BB77F9B64D67_1_105_c.6c25aab4.jpeg";